import { useTranslation } from "../../i18n/TranslationProvider";
import { SUPPORTED_LANGUAGES } from "../../i18n/supportedLanguages";

const LanguageSelector = () => {
    const { language, setLanguage, t } = useTranslation();

    return (
        <div className="flex items-center gap-2">
            <label htmlFor="languageSelector" className="text-sm text-gray-600">
                {t("header.language")}
            </label>
            <select
                id="languageSelector"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="text-teal-600 bg-transparent border focus:border-teal-200 rounded-md text-sm py-1 px-2 cursor-pointer focus:outline-none focus:ring-1 focus:ring-teal-400"
            >
                {SUPPORTED_LANGUAGES.filter((item) => item.enabled).map((item) => (
                    <option key={item.code} value={item.code}>
                        {item.nativeLabel}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default LanguageSelector;